import { Injectable } from "@angular/core";
import { CanActivate, Router, ActivatedRouteSnapshot } from "@angular/router";
import { ServerCommunicatorService } from "../../services/server-communicator.service";
import { UserLoginRequest } from "../../classes/infrastructure/request_response/userloginrequest";
import { AppStateManageService } from "../../services/app-state-manage.service";
import { UserLogoutRequest } from "../../classes/infrastructure/request_response/userlogoutrequest";
import { FilterDataUPTOLevelsService } from "../../services/hierarchy.service";
import { HierarchyFilterService } from "../../services/hierarchyfilterwithmonthyearlevel.service";
import { SidebarMenuStateService } from "../../services/sidebarmenustateservice";
import { filter, map, Observable, take } from "rxjs";
import { SUBMENU_ID } from "../../classes/domain/constants";

export interface IUser {
  email: string;
  avatarUrl?: string;
}

const defaultPath = "/";
const defaultUser = {
  email: "sandra@example.com",
  avatarUrl:
    "https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png",
};

@Injectable({ providedIn: "root" })
export class AuthService {
  // private _user: IUser | null = defaultUser;
  private _user: IUser | null = null;
  get loggedIn(): boolean {
    return !!this._user;
  }

  // private _lastAuthenticatedPath: string = defaultPath;
  private _lastAuthenticatedPath: string = "/home";

  set lastAuthenticatedPath(value: string) {
    this._lastAuthenticatedPath = value;
  }

  constructor(
    private router: Router,
    private serverCommunicatorService: ServerCommunicatorService,
    private appStateManage: AppStateManageService,
    private FilterStateService: FilterDataUPTOLevelsService,
    public FilterStateServiceMonthWise: HierarchyFilterService,
  ) {}

  async logIn(loginReq: UserLoginRequest) {
    try {
      // Send request
      // this._user = { ...defaultUser, email };
      let response = await this.serverCommunicatorService.LoginUser(loginReq);
      console.log("response logiiin :", response);
      //response.Successful = true;
      if (!response.successful) {
        return {
          successful: false,
          message: response.message,
        };
      }
      // this.router.navigate([this._lastAuthenticatedPath]);

      return {
        successful: true,
        message: response.message,

        FirstLoginCompleted: response.first_login_completed,
        LoginUserRef: response.login_user_id,
        LoginUserToken: response.login_token,
        CurrentFinancialYear: response.short_name,
        Role: response.role,
        RoleName: response.role_name,
        UserDisplayName: response.user_display_name,
        PostRef: response.post_id,
        UnderSupervisionPostRef: response.under_supervision_post_ref,
        FinancialYearResponses: response.financial_year_responses,
        Months: response.months,
        ValidMenuItemIds2: response.valid_web_menu_item_ids ,
        LanguagePreference: response.language_preference,

        PHCNameEn: response.phc_name_en,
        PHCNameMr: response.phc_name_mr,
        SCNameEn: response.sc_name_en,
        SCNameMr: response.sc_name_mr,
        VillageNameEn: response.village_name_en,
        VillageNameMr: response.village_name_mr,

        UserDisplayNameEn: response.user_display_name_en,
        UserDisplayNameMr: response.user_display_name_mr,
        RoleNameEn: response.role_name_en,
        RoleNameMr: response.role_name_mr,
      };
    } catch {
      return {
        successful: false,
        message: "Authentication failed",
      };
    }
  }

  async getUser() {
    try {
      // Send request

      return {
        isOk: true,
        data: this._user,
      };
    } catch {
      return {
        isOk: false,
        data: null,
      };
    }
  }

  async createAccount(email: string, password: string) {
    try {
      // Send request

      this.router.navigate(["/create-account"]);
      return {
        isOk: true,
      };
    } catch {
      return {
        isOk: false,
        message: "Failed to create account",
      };
    }
  }

  async changePassword(email: string, recoveryCode: string) {
    try {
      // Send request

      return {
        isOk: true,
      };
    } catch {
      return {
        isOk: false,
        message: "Failed to change password",
      };
    }
  }

  async resetPassword(email: string) {
    try {
      // Send request

      return {
        isOk: true,
      };
    } catch {
      return {
        isOk: false,
        message: "Failed to reset password",
      };
    }
  }

  async logOut() {
    try {
      this.FilterStateService.resetFilters(); // We can reset all service states //
      this.FilterStateServiceMonthWise.resetFilters(); // We can reset all service states //

      // // Send request
      // // this._user = { ...defaultUser, email };
      // if (this.appStateManage.getLoginUserRef() <= 0) {
      //   alert("Login user not Specified");
      //   return
      // }
      // else
      if (this.appStateManage.getLoginToken() == "" || null || undefined) {
        alert("Login Token not Specified");
        return;
      }

      let logoutRequest = new UserLogoutRequest();
      logoutRequest.login_token = this.appStateManage.getLoginToken();
      // logoutRequest.LoginUserRef = this.appStateManage.getLoginUserRef();

      let response =
        await this.serverCommunicatorService.LogoutUser(logoutRequest);
      if (!response.Successful) {
        return {
          Successful: false,
          message: response.Message,
        };
      }

      //clear storage in serverCommunicatorService.LogoutUser()
      // Clear state
      SidebarMenuStateService.GetInstance().clearState();
      this.router.navigate(["/Landing_Page"]);
      // this.router.navigate(['/Landing_Page']);

      return {
        Successful: true,
        message: "",
      };
    } catch {
      return {
        Successful: false,
        message: "Authentication failed",
      };
    }
  }
}

@Injectable({ providedIn: "root" })
// export class AuthGuardService implements CanActivate {
//   constructor(private router: Router, private authService: AuthService, private appStateManage: AppStateManageService,
//   ) { }

//   canActivate(route: ActivatedRouteSnapshot): boolean {
//     const isLoggedIn = this.authService.loggedIn;
//     const isAuthForm = [
//       'login-form',
//       'reset-password',
//       'create-account',
//       'forgot-password',
//       'create-new-password',
//       'otp-verification',
//       'Change_Password',
//       'change-password/:recoveryCode'
//     ].includes(route.routeConfig?.path || defaultPath);

//     const CurrentLoginToken = this.appStateManage.StorageKey.getItem('CurrentLoginToken');
//     const LoginEmployeeRef = Number(this.appStateManage.StorageKey.getItem('LoginEmployeeRef'));

//     if (CurrentLoginToken && isAuthForm && LoginEmployeeRef) {
//       this.authService.lastAuthenticatedPath = defaultPath;
//       this.router.navigate([defaultPath]);
//       return false;
//     }

//     if (!CurrentLoginToken && !isAuthForm && !LoginEmployeeRef) {
//       this.router.navigate(['/login-form']);
//     }

//     if (isLoggedIn) {
//       this.authService.lastAuthenticatedPath = route.routeConfig?.path || defaultPath;
//     }

//     return isLoggedIn || isAuthForm;
//   }
// }
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private appStateManage: AppStateManageService,
    private sidebarMenuState: SidebarMenuStateService, // 👈 inject this
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    const isAuthForm = [
      "Landing_Page",
      "login-form",
      "reset-password",
      "create-account",
      "forgot-password",
      "create-new-password",
      "otp-verification",
      "Change_Password",
      "change-password/:recoveryCode",
      `${SUBMENU_ID.PRIVACY_POLICY}`,
      `${SUBMENU_ID.TERMS_AND_CONDITIONS}`,
    ].includes(route.routeConfig?.path || "/");

    const CurrentLoginToken =
      this.appStateManage.StorageKey.getItem("CurrentLoginToken");
    const LoginEmployeeRef = Number(
      this.appStateManage.StorageKey.getItem("LoginEmployeeRef"),
    );

    // Already logged in, trying to access auth pages → redirect to dashboard
    if (CurrentLoginToken && isAuthForm && LoginEmployeeRef) {
      this.authService.lastAuthenticatedPath = "/";
      this.router.navigate(["/"]);
      return false;
    }

    // Not logged in, trying to access protected pages → redirect to login
    if (!CurrentLoginToken && !isAuthForm && !LoginEmployeeRef) {
      this.router.navigate(["/login-form"]);
      return false;
    }

    // ✅ Auth pages don't need service data — allow immediately
    if (isAuthForm) {
      return true;
    }

    // ✅ Protected pages — wait until sidebar/menu state is fully ready
    return this.sidebarMenuState.isReady$.pipe(
      filter((isReady) => isReady === true),
      take(1),
      map(() => {
        this.authService.lastAuthenticatedPath = route.routeConfig?.path || "/";
        return true;
      }),
    );
  }
}
